import { render, staticRenderFns } from "./AutosizeTextarea.vue?vue&type=template&id=657eb32f&"
import script from "./AutosizeTextarea.vue?vue&type=script&lang=ts&"
export * from "./AutosizeTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports